var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 3 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2192 3.70703H16.84C17.9688 3.70703 18.8839 4.67718 18.8839 5.87376V17.7908C18.8839 18.9874 17.9688 19.9575 16.84 19.9575H11.2192",
    stroke: "#26904E",
    strokeWidth: 1.62295,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2196 20.4788C11.2196 21.1624 10.6294 21.6754 9.99733 21.541L2.23248 19.8949C1.51558 19.7432 1 19.0764 1 18.3018V4.82362C1 4.04902 1.51558 3.3822 2.23248 3.22999L9.99733 1.58382C10.6294 1.45002 11.2196 1.963 11.2196 2.6466V20.4788Z",
    stroke: "#26904E",
    strokeWidth: 1.62295,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 7.5H15.8183",
    stroke: "#26904E",
    strokeWidth: 1.62295,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 11.832H15.8183",
    stroke: "#26904E",
    strokeWidth: 1.62295,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 16.168H15.8183",
    stroke: "#26904E",
    strokeWidth: 1.62295,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71491 8.37064L4.71498 8.37074L8.29172 14.3291C8.29173 14.3291 8.29174 14.3291 8.29175 14.3291C8.44777 14.5895 8.37005 14.9304 8.13724 15.0877L8.13684 15.088C8.05489 15.1436 7.96596 15.1687 7.87787 15.1687C7.72125 15.1687 7.56068 15.0863 7.46222 14.9232C7.46218 14.9231 7.46214 14.9231 7.4621 14.923L3.88563 8.96515C3.8856 8.96511 3.88558 8.96506 3.88555 8.96502C3.72965 8.70468 3.80727 8.36402 4.03988 8.20662C4.26322 8.05654 4.56427 8.11943 4.71491 8.37064Z",
    fill: "#26904E",
    stroke: "#26904E",
    strokeWidth: 0.540984
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03964 15.0877C4.12248 15.143 4.21243 15.1684 4.29999 15.1684C4.45712 15.1684 4.61736 15.0862 4.71503 14.9236L8.29172 8.96539C8.29174 8.96535 8.29176 8.96532 8.29178 8.96528C8.44774 8.70489 8.37005 8.36412 8.13732 8.20676L4.03964 15.0877ZM4.03964 15.0877C3.80721 14.9302 3.7297 14.5896 3.88557 14.3294C3.88559 14.3294 3.88561 14.3293 3.88563 14.3293L7.4623 8.37111C7.46232 8.37107 7.46234 8.37104 7.46236 8.371C7.61387 8.11905 7.91506 8.05673 8.13724 8.2067L4.03964 15.0877Z",
    fill: "#26904E",
    stroke: "#26904E",
    strokeWidth: 0.540984
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f3e658218cd35374e1e54667aa0ea706.svg";
export { ForwardRef as ReactComponent };